// extracted by mini-css-extract-plugin
export default {"num-items-message":"ModuleItemCount_num-items-message__XNIlW","numItemsMessage":"ModuleItemCount_num-items-message__XNIlW"};